<template>
  <div class="Details Services">
    <Navbar title="Yajobici" />
    <div class="mt-5 mb-1" style="margin-top: 125px !important"></div>

    <!-- Header End -->
    <div
      class="page-header mb-5"
      style="background-color: #61c7f2 !important"
    >
      <div class="container pt-4 pb-4">
        <h2 class="text-white mb-2 animated slideInDown">
          {{ subCategorieName }}
        </h2>
      </div>
    </div>
    <!-- Header End -->

    <div class="container p-0">

        <!-- acteurs by domaines -->
        <div class="mt-5 mb-5">

          <h1 class="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
            Explorer nos prestataires
          </h1>

          <div v-if="isLoading" class="text-center">
            <span style="color: #f7a51b !important">
              Recuperation de la liste des prestataires ...
            </span>
          </div>

          <div v-else class="row m-5">
            <div
              v-if="listPrestataire.length == 0"
              class="col-xl-3 col-sm-2 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <span class="text-danger"
                >Il n'y a pas de prestataire disponible pour ce service
                :)</span
              >
            </div>

            <div
              v-else
              v-for="lp in listPrestataire"
              :key="lp.prestataire.id"
              class="col-md-6 col-lg-4 mb-4 wow fadeInUp"
              data-wow-delay="0.1s"
              @click.prevent="
                redirectToDetailActeur(
                  lp.prestataire.id,
                  lp.metier.id,
                  lp
                )
              "
            >

              <div class="sr-card p-4">

                <div class="d-flex align-items-center">
                  <img
                    :src="lp.prestataire.profile.photo"
                    @error="handleImageError"
                    loading="lazy"
                    decoding="async"
                    class="avatar-md rounded-circle img-thumbnail"
                  />

                  <div class="ms-3">
                    <h5 class="mb-1">
                      {{ lp.prestataire.profile.nom }}
                      {{ lp.prestataire.profile.prenoms }}
                    </h5>
                    <span class="role">
                      {{ lp.metier.libelle }}
                    </span>
                  </div>
                </div>

                <!-- badge -->
                  <span 
                      v-for="badge in lp.badges" 
                      :key="badge.id"
                      class="badge me-1 mt-2"
                      :style="{ backgroundColor: badge.color, color: '#fff' }"
                      >
                      <i :class="['fa', badge.icon, 'me-1']"></i> {{ badge.name }}
                  </span>
                  <!-- badge -->

                <div class="mt-3">
                  <p class="text-muted mb-1">
                      <i class="mdi mdi-google-maps font-size-15 align-middle pe-2 text-primary"
                      ></i>
                    {{ lp.prestataire.profile.adresse }}
                  </p>

                  <p class="text-muted mt-2">
                      <i
                      class="mdi mdi-road font-size-15 align-middle pe-2 text-primary"
                      ></i>
                      <span
                      v-if="lp.distance_en_km != 'Non disponible'"
                      style="
                          color: #f7a51b !important;
                          font-size: 12px !important;
                      "
                      >À
                      <b
                          style="
                          color: #61c7f2 !important;
                          font-weight: bold !important;
                          "
                          >{{ lp.distance_en_km }}</b
                      >
                      de vous</span
                      >
                      <span v-else style="color: red !important">{{
                      lp.distance_en_km
                      }}</span>
                  </p>
                </div>

              </div>

            </div>

          </div>

        </div>
        <!-- acteurs by domaines -->

    </div>

    <!-- Footer Start -->
      <Footer />
    <!-- Footer End -->
  </div>
</template>

<script>
import Navbar from "../../components/Navbar.vue";
import Footer from "../../components/Footer.vue";
import router from "@/router";
export default {
  name: "DetailService",
  components: {
    Navbar,
    Footer,
  },
  data() {
    return {
      listPrestataire: [],
      subCategorieName: "",
      isLoading: false,
      visitorLat: "",
      visitorLng: "",
    };
  },
  beforeMount() {
    this.locatorFetch();
  },
  mounted() {
    this.subCategorieName = this.$route.params.subcatName;
  },
  methods: {
    handleImageError(event) {
      event.target.src = require('../../assets/img/avatar.png');
    },
    async getPrestataireBySousCategorie(subCatId) {
      this.isLoading = true;
      await this.$store
        .dispatch("staticdata/searchPrestataireBySubCategorie", subCatId)
        .then(
          (response) => {
            this.isLoading = false;
            for (let index = 0; index < response.data.length; index++) {
              const element = response.data[index];

              const actorLat = element.prestataire.profile.localisation.lat,
                actorLng = element.prestataire.profile.localisation.long;
              var _d =
                this.visitorLat != "" && this.visitorLng
                  ? Math.round(
                      this._getDistanceFromLatLonInKm(
                        this.visitorLat,
                        this.visitorLng,
                        actorLat,
                        actorLng
                      ) * 100
                    ) /
                      100 +
                    " Km"
                  : "Non disponible";
              element.distance_en_km = _d;
            }
            this.listPrestataire = response.data;
          },
          (error) => {
            this.isLoading = false;
            console.log("error--- ", error);
          }
        );
    },
    async redirectToDetailActeur(prestataireId, metierId, selectedUserInfos) {
      // Conversion de proxy en objet
      var arrayData = Object.assign({}, selectedUserInfos),
        metierDara = Object.assign({}, arrayData.metier),
        prestaDara = Object.assign({}, arrayData.prestataire),
        profileData = Object.assign({}, prestaDara.profile),
        apiUserDara = Object.assign({}, profileData.user),
        userReData = {
          full_name: profileData.nom + " " + profileData.prenoms,
          contact: apiUserDara.contact,
          adresse: profileData.adresse,
          photo_url: profileData.photo,
          categorie: prestaDara.categorie,
          metier: metierDara.libelle,
          description: arrayData.description,
        },
        //
        dataToJson = JSON.stringify(userReData);
      var authData = Object.assign(
          {},
          JSON.parse(localStorage.getItem("authUser"))
        ),
        authToken = authData.token;
      if (authToken) {
        await localStorage.removeItem("selectedUserData");
        await localStorage.setItem("selectedUserData", dataToJson);

        router.push({
          name: "detailActeur",
          params: { prestataireId: prestataireId, metierId: metierId },
        });
      } else {
        router.push({ name: "Login" });
      }
    },
    _getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
      var R = 6371; // Radius of the earth in kilometers
      var dLat = this.deg2rad(lat2 - lat1); // deg2rad below
      var dLon = this.deg2rad(lon2 - lon1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) *
          Math.cos(this.deg2rad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c; // Distance in KM
      return d;
    },

    deg2rad(deg) {
      return deg * (Math.PI / 180);
    },
    locatorFetch() {
      this.isLoading = true;
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.isLoading = false;
          this.visitorLat = position.coords.latitude;
          this.visitorLng = position.coords.longitude;
          this.getPrestataireBySousCategorie(this.$route.params.subcatId);
        },
        (error) => {
          this.isLoading = false;
          this.getPrestataireBySousCategorie(this.$route.params.subcatId);
          console.log(error.message);
        }
      );
    },
  },
};
</script>

<style scoped>

a {
  text-decoration: none !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.sr-card {
  transition: all 0.3s ease;
  cursor: pointer;
  border-radius: 15px !important;
  background-color: #fff;
  border: 1px solid #eff0f2;
  border-bottom: 4px solid #61c7f2;
  height: 100% !important;
}

.sr-card:hover {
  transform: translateX(8px);
  box-shadow: 0 20px 40px rgba(97, 199, 242, 0.35);
  border-bottom: 10px solid #61c7f2 !important; 
  border-radius: 80px 15px 80px 15px !important; 
}

.avatar-md {
  width: 70px;
  height: 70px;
  border: 1px dotted #61c7f2;
  object-fit: cover;
}

.role {
  background: linear-gradient(135deg, #ecfeff, #e0f2fe);
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: #0284c7;
}

</style>